import React from "react";
import { Link } from "gatsby";
import { PrismicRichText } from "@prismicio/react";
import kebabCase from "lodash.kebabcase";

import { AspectRatioImageContainer } from "../containers/aspect-ratio-image-container";
import { GatsbyImage } from "gatsby-plugin-image";

import {
  getArtistNameFromMetafields,
  shopifySizedSrc,
} from "../../utils/shopify-product";

const ARTWORK_THUMB_SIZES = `(max-width: 800px) 92vw, min(920px, 58vw)`;

export const ArtistArtwork = ({
  content,
  shopsByHandle,
  artistPageTitle,
}) => {
  const artwork = content.primary.artwork;
  const isActive =
    artwork !== null &&
    (artwork.status === `ACTIVE` || artwork.status === `active`);

  const shopifyProduct =
    artwork !== null && artwork.handle ? shopsByHandle[artwork.handle] : null;

  const artistSlug =
    shopifyProduct != null
      ? getArtistNameFromMetafields(shopifyProduct.metafields)
      : ``;

  let to = `/shop/`;
  if (isActive && artwork) {
    if (artistSlug !== ``) {
      to = `/${kebabCase(artistSlug)}/${artwork.handle}/`;
    }
  }

  const linkState =
    artistPageTitle != null ? { activeArtistFilter: artistPageTitle } : undefined;

  const thumb = content.primary.artwork_thumbnail;
  const hasThumb = thumb?.gatsbyImageData != null;
  const featuredGatsby = shopifyProduct?.featuredImage?.gatsbyImageData ?? null;

  const imageAlt = artwork?.title ?? thumb?.alt ?? ``;

  let imageInner = null;
  if (hasThumb) {
    imageInner = (
      <GatsbyImage
        image={thumb.gatsbyImageData}
        alt={imageAlt || `Artwork`}
        loading="lazy"
        decoding="async"
        sizes={ARTWORK_THUMB_SIZES}
        onContextMenu={(e) => e.preventDefault()}
        draggable={false}
      />
    );
  } else if (featuredGatsby != null) {
    imageInner = (
      <GatsbyImage
        image={featuredGatsby}
        alt={imageAlt || `Artwork`}
        loading="lazy"
        decoding="async"
        sizes={ARTWORK_THUMB_SIZES}
        onContextMenu={(e) => e.preventDefault()}
        draggable={false}
      />
    );
  } else if (artwork !== null) {
    imageInner = (
      <AspectRatioImageContainer
        image={null}
        padding={(artwork.image.height / artwork.image.width) * 100}
      >
        <img
          src={shopifySizedSrc(artwork.image.src, 1000)}
          alt={imageAlt || `Artwork`}
          onContextMenu={(e) => e.preventDefault()}
          draggable={false}
          decoding="async"
          loading="lazy"
        />
      </AspectRatioImageContainer>
    );
  }

  return (
    <div
      className={`single-module artwork-container position-${kebabCase(
        content.primary.artwork_position
      )} size-${kebabCase(content.primary.artwork_size)}`}
    >
      <Link to={to} state={linkState}>
        {imageInner}
      </Link>

      {artwork !== null ? (
        <p>{artwork.title}</p>
      ) : (
        <PrismicRichText field={content.primary.artwork_title.richText} />
      )}
    </div>
  );
};
